import {
  DataDeclarationIcaro,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { DateTime } from 'luxon';
import { formatNameIcaro, formatSurnameIcaro } from '../format-surname-name-icaro';

export const transformerDeclarant = (data: DataDeclarationIcaro): SubjectIcaroVM | undefined => {
  if (!data) {
    return undefined;
  }

  return {
    freshman: data.matricolaDichiarante?.toString() || '',
    numberFamily: data.numeroFamigliaDichiarante?.toString() || '',
    surname: formatSurnameIcaro(data.cognomeNomeDichiarante),
    name: formatNameIcaro(data.cognomeNomeDichiarante),
    dateBorn: data.dataNascitaDichiarante
      ? DateTime.fromFormat(data.dataNascitaDichiarante, 'yyyyMMdd')
      : null,
    municipalityBorn: `${data.comuneNascitaDichiaranteDescrizione || ''} ${
      data.provNascitaDichiaranteDescrizione ? `(${data.provNascitaDichiaranteDescrizione})` : ''
    }`,
    municipalityResidence: `${data.comuneResidenzaDichiaranteDescrizione || ''} ${
      data.provResidenzaDichiaranteDescrizione
        ? `(${data.provResidenzaDichiaranteDescrizione})`
        : ''
    }`,
    guise: data.vesteDichiarante || '',
  };
};
